<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="6" height="6" rx="0.5" stroke="#404A57" />
    <rect x="1.5" y="10.5" width="6" height="6" rx="0.5" stroke="#404A57" />
    <rect x="10.5" y="1.5" width="6" height="6" rx="0.5" stroke="#404A57" />
    <rect x="10.5" y="10.5" width="6" height="6" rx="0.5" stroke="#404A57" />
  </svg>
</template>

<script>
export default {
  name: "IconDashboard",
};
</script>

<style></style>
